export const GET_BUILDING_MATERIAL_TYPE = '/building_material_type/get_building_material_type';
export const GET_SINGLE_BUILDING_MATERIAL_TYPE = '/building_material_type/get_single_building_material_type';
export const CREATE_BUILDING_MATERIAL_TYPE = '/building_material_type/create_building_material_type';
export const UPDATE_BUILDING_MATERIAL_TYPE = '/building_material_type/update_building_material_type';
export const REMOVE_BUILDING_MATERIAL_TYPE = '/building_material_type/remove_building_material_type';

export const CREATE_BUILDING_MATERIAL = 'building_material/create_building_material';
export const UPDATE_BUILDING_MATERIAL = 'building_material/update_building_material';
export const REMOVE_BUILDING_MATERIAL = 'building_material/remove_building_material';

export const FORM_DATA = {
  name: '',
  description: '',
  is_active: '',
};